import { createContext } from 'react';

export const ActiveRecordContext = createContext(undefined);
